import React from 'react';

import PropTypes from 'prop-types';

import Page from '../../components/page';
import { linksMessages as headerMessages } from '../messages';
import ReportsContextProvider from './context';
import { ReportPages } from './report-pages';
import ReportOutput from './report-output';

const ReportPage = ({ page }) => {
  const Report = ReportPages[page];
  return (
    <ReportsContextProvider page={page}>
      <Page messages={{ headerMessage: headerMessages[page] }}>
        <Report />
        <ReportOutput />
      </Page>
    </ReportsContextProvider>
  );
};

ReportPage.propTypes = {
  page: PropTypes.string.isRequired,
};

export default ReportPage;
